<template>
    <div class="visual-sly" ref="sly" :class="[{'is-open': isOpen}]">
        <div class="visual-sly__open-button-wrapper">
            <button class="button button_theme_stroke button_theme_content-width visual-sly__open-button"
                    @click="isOpen = true">
                <span>Этаж {{currentFloorNumber}}</span>
                <span class="visual-sly__open-button-arrows">
                    <iconArrowTop/>
                    <iconArrowBottom/>
                </span>
            </button>
        </div>
        <div class="visual-sly__title">Этаж</div>

        <div class="visual-sly__container">
            <button class="button-circle button-circle_theme_stroke visual-sly__close-button" @click="isOpen = false">
                <iconClose className="visual-rotate__svg-close"/>
            </button>

            <div class="visual-sly__wrapper">
                <button class="visual-sly__prev" ref="sly_prev">
                    <iconArrowTop/>
                </button>

                <div class="visual-sly__wrap" ref="list">
                    <ul class="visual-sly__list">
                        <li v-for="floor in floors"
                            :key="floor.id"
                            :class="['visual-sly__item', {'is-disabled':floor.disabled}]"
                            @click="setFloor(floor.id)"
                            ref="list_item">

                            <div v-if="isParking === true" class="visual-sly__rooms">
                                {{floor.elements[rotate].length}}
                            </div>

                            <button class="visual-sly__button" :disabled="floor.disabled">
                                {{floor.floorNum}}
                            </button>
                        </li>
                    </ul>
                </div>

                <button class="visual-sly__next" ref="sly_next">
                    <iconArrowBottom/>
                </button>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    @import "./Sly.scss";
</style>
<script>
import './dist/sly';
import {mapActions, mapGetters} from 'vuex';
import iconArrowBottom from '../Icons/icon-arrow-bottom';
import iconArrowTop from '../Icons/icon-arrow-top';
import iconClose from '../Icons/icon-close';

export default {
    props: ['isParking'],

    data: () => {
        return {
            isOpen: false
        };
    },

    components: {
        iconArrowTop,
        iconArrowBottom,
        iconClose
    },

    watch: {
        isOpen(val) {
            /* Отпускаем у хеадера z-index  */
            if (!this.header) {
                this.header = document.querySelector('.header');
            }

            if (val) {
                this.header.style.zIndex = 1;
            } else {
                this.header.removeAttribute('style');
            }
        }
    },

    computed: {
        ...mapGetters({
            floors: 'GET_FLOORS',
            rotate: 'GET_ROTATE'
        }),

        currentFloorId() {
            return this.$route.params.floorId;
        },

        currentFloor() {
            return this.floors.find((item) => {
                return item.id === this.currentFloorId;
            });
        },

        currentFloorNumber() {
            return this.currentFloor.floorNum;
        }
    },

    mounted() {
        this.initSly();
    },

    methods: {
        ...mapActions(['changeFloor', 'send']),

        initSly() {
            const defaultItemsNumber = 7;
            const slySelector = this.$refs.sly;
            const slyListSelector = this.$refs.list;
            const slyItemsLength = this.$refs.list_item.length;

            // Расчет ширины контейнера если элементов меньше 7
            if (slyItemsLength < defaultItemsNumber) {
                slyListSelector.style.height = '100%';
            }

            const Sly = window.Sly;
            const startAt = this.floors.indexOf(this.currentFloor);

            const options = {
                horizontal    : false,
                itemNav       : 'basic',
                smart         : 1,
                activateOn    : 'click',
                activateMiddle: 1,
                mouseDragging : 1,
                touchDragging : 1,
                releaseSwing  : 1,
                startAt,
                scrollBy      : 1,
                speed         : 300,
                dragHandle    : 1,
                dynamicHandle : 1,
                clickBar      : 1,
                prevPage      : this.$refs.sly_prev,
                nextPage      : this.$refs.sly_next
            };

            const sly = new Sly(slyListSelector, options, {
                load: () => {
                    slySelector.style.opacity = 1;
                }
            });

            sly.init();
        },

        setFloor(floor) {
            if (floor === this.currentFloorId) {
                return;
            }

            let isFloor = '';

            if (this.isParking) {
                isFloor = 'parking';
            } else {
                isFloor = 'flat';
            }

            const url = this.$route.path.replace(/floor[/]\d*/, `floor/${floor}`);
            const body = {
                step    : isFloor,
                building: this.$route.params.buildingId || '',
                section : this.$route.params.sectionId || '',
                floor
            };

            this.isOpen = false;
            this.$router.push(url);
            this.send(body);
        }
    }
};
</script>
